<template>
  <div class="courseTypeModal">
    <Modal v-model="show" :footer-hide="true" :closable="false" title="导出">
      <div>
        <div class="modal-select">
          <div class="title">班级课程类型</div>
          <CourseTypes
            ref="courseTypesRef"
            :type-ids="typeList"
            class="content"
          ></CourseTypes>
        </div>
        <div class="modal-select">
          <div class="title">含节次上课提醒</div>
          <RadioGroup v-model="nextClassReminder" class="content">
            <Radio label="FALSE" style="margin-right: 40px">否</Radio>
            <Radio label="TRUE">是</Radio>
          </RadioGroup>
        </div>
        <div class="modal-select">
          <RemarkCard>
            <h2>说明：</h2>
            <p>
              ①根据所选的课程类别，将在去向表中显示是否包含该课程类型的课程班级。
            </p>
            <p>
              ②节次上课提醒：如果当前班级后，学生还有课程班级需要，则会在姓名下新增【下节有课】
            </p>
          </RemarkCard>
        </div>
        <div class="price-btn-box">
          <Button @click="handleSelectCancle">取消</Button>
          <Button type="primary" @click="handleSelectSubmit">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import CourseTypes from '@c/Base/CourseTypes.vue';
import RemarkCard from '@c/Base/RemarkCard.vue';
export default {
  components: {
    CourseTypes,
    RemarkCard
  },
  props: {
    isSelect: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      show: false,
      typeList: [11, 12, 13, 14, 15, 23], // 课程类型-默认
      nextClassReminder: 'TRUE' //	下节有课提醒

    };
  },
  methods: {
    getExReset() {
      this.typeList = [11, 12, 13, 14, 15, 23];
      this.placeFlag = '1';
    },
    handleShow() {
      this.show = true;
    },
    handleHide() {
      this.show = false;
    },
    handleSelectCancle() {
      this.handleHide();
    },
    handleSelectSubmit() {
      const reData = this.$refs.courseTypesRef ? this.$refs.courseTypesRef.getResult() : [];
      this.$emit('on-finish', {
        nextClassReminder: this.nextClassReminder,
        courseTypesData: reData
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.price-btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 24px;
  }
}
.modal-select {
  margin-bottom: 20px;
  .title {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .content {
    padding: 0 10px;
  }
}
</style>
